(function () {
    'use strict';
    var LabResultsBaseCtrl = function (autoInit) {
        return function ($scope, $stateParams, MyChartService, PatientPortalStorageRepository, $modal, PersonRepository, PatientAttachmentRepository, gettext, toaster, BrowserService) {
            $scope.loading = false;
            $scope.isModalDisplayed = false;

            var activePatient = PatientPortalStorageRepository.getActivePatient(),
                loginUser = PatientPortalStorageRepository.getLoginUser(),
                reportRequestDto = {
                    PatientId: activePatient.id,
                    LoginUserId: loginUser.id,
                    LoginUserName: loginUser.name
                };

            function initialize() {
                $scope.loading = true;
                $scope.removeHttpError();
                MyChartService
                    .getLabResults(activePatient.id)
                    .then(function (data) {
                        $scope.labResults = _(data.plain()).map(function (entry) {
                            if (entry.AttachmentInfos.length) {
                                entry.AttachmentInfos = _(entry.AttachmentInfos).map(function (attachmentInfo) {
                                    return _.assign(attachmentInfo, {Downloading: false});
                                }).value();
                                return entry;
                            } else {
                                entry.Result = _.assign(entry.Result, {Downloading: false});
                                return entry;
                            }
                        }).value();
                        auditLabResults();
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            }

            function viewLabResultAttachment(description, attachmentInfo) {
                $scope.isModalDisplayed = true;

                var modalConfig = {
                    Title: description,
                    PatientId: activePatient.id,
                    DocumentId: attachmentInfo.AttachmentUid,
                    DocumentLoad: getLabResultAttachment,
                    DocumentDownload: downloadLabResultAttachmentOriginalFormat,
                    DisableInlinePdf: !BrowserService.supportsInlinePdf(),
                };

                var modalInstance = $modal.open({
                    templateUrl: '/app/views/viewDocumentModal.html',
                    controller: 'ViewDocumentModalCtrl',
                    windowClass: 'modal-full',
                    resolve: {
                        modalConfig: function () {
                            return modalConfig;
                        }
                    }
                });

                modalInstance.result.then(function () {
                    $scope.isModalDisplayed = false;
                });
            }
            
            function getLabResultAttachment(documentId, requestSettings) {
                return PatientAttachmentRepository.getAttachment(documentId, activePatient.id, requestSettings)
                    .then(function (data) {
                        auditLabResults();
                        return data;
                    });
            }

            function downloadLabResultAttachmentOriginalFormat(documentId) {
                return PatientAttachmentRepository.getAttachmentRetainOriginalFormat(documentId, activePatient.id)
                    .then(function (data) {
                        auditLabResults();
                        return data;
                    });
            }

            function downloadLabResultAttachment(description, attachmentInfo) {
                attachmentInfo.Downloading = true;
                return PersonRepository.getAttachment(activePatient.id, attachmentInfo.AttachmentUid)
                    .then(function (data) {
                        auditLabResults();
                        return {Data: data.Data, Extension: data.Extension, FileName: description + '_' + activePatient.firstName + activePatient.lastName};
                    })
                    .catch(function () {
                        toaster.pop('error', '', gettext('An error occurred while downloading'));
                    })
                    .finally(function () {
                        attachmentInfo.Downloading = false;
                    });
            }

            function viewLabResultObservation(description, resultId) {
                $scope.isModalDisplayed = true;

                var modalConfig = {
                    Title: description,
                    DownloadFileName: '',
                    PatientId: activePatient.id,
                    DocumentId: resultId,
                    DocumentLoad: getObservationOrderPdf,
                    DocumentDownload: getObservationOrderPdf,
                    DisableInlinePdf: !BrowserService.supportsInlinePdf(),
                };

                var modalInstance = $modal.open({
                    templateUrl: '/app/views/viewDocumentModal.html',
                    controller: 'ViewDocumentModalCtrl',
                    windowClass: 'modal-full',
                    resolve: {
                        modalConfig: function () {
                            return modalConfig;
                        }
                    }
                });

                modalInstance.result.then(function () {
                    $scope.isModalDisplayed = false;
                });
            }

            function getObservationOrderPdf(documentId) {
                return PersonRepository.getObservationOrderPdf(activePatient.id, documentId)
                    .then(function (data) {
                        auditLabResults();
                        return data;
                    });
            }

            function downloadLabResultObservation(labResult) {
                labResult.Downloading = true;
                return PersonRepository.getObservationOrderPdf(activePatient.id, labResult.Id)
                    .then(function (data) {
                        auditLabResults();
                        return {Data: data.Data, Extension: 'pdf', FileName: labResult.Description + '_' + activePatient.firstName + activePatient.lastName};
                    })
                    .catch(function () {
                        toaster.pop('error', '', gettext('An error occurred while downloading'));
                    })
                    .finally(function () {
                        labResult.Downloading = false;
                    });
            }

            function auditLabResults() {
                MyChartService.auditLabResultsLogging(reportRequestDto);
            }

            $scope.tileState = {
                isCollapsed: undefined
            };

            function toggleState() {
                if ($scope.tileState.isCollapsed === undefined) {
                    initialize();
                    $scope.tileState.isCollapsed = false;
                }
                else
                    $scope.tileState.isCollapsed = !$scope.tileState.isCollapsed;
            }

            if(autoInit) {
                initialize();
            }

            $scope.viewLabResultAttachment = viewLabResultAttachment;
            $scope.getLabResultAttachment = getLabResultAttachment;
            $scope.downloadLabResultObservation = downloadLabResultObservation;
            $scope.viewLabResultObservation = viewLabResultObservation;
            $scope.downloadLabResultAttachment = downloadLabResultAttachment;
            $scope.getObservationOrderPdf = getObservationOrderPdf;
            $scope.toggleState = toggleState;
        };
    };
    var LabResultsCtrl = new LabResultsBaseCtrl(true);
    var LabResultsMobileCtrl = new LabResultsBaseCtrl(false);

    angular.module('mychart').controller('LabResultsCtrl',
        ['$scope', '$stateParams', 'MyChartService', 'PatientPortalStorageRepository', '$uibModal', 'PersonRepository', 'PatientAttachmentRepository', 'aprgettext', 'toaster',
        'BrowserService',
            LabResultsCtrl]);
    angular.module('mychart').controller('LabResultsMobileCtrl',
        ['$scope', '$stateParams', 'MyChartService', 'PatientPortalStorageRepository', '$uibModal', 'PersonRepository', 'PatientAttachmentRepository', 'aprgettext', 'toaster',
        'BrowserService',
            LabResultsMobileCtrl]);
})();